import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {  MatDialogModule } from '@angular/material/dialog';
import { DpTableComponent } from '../../../common-component/dp-table/dp-table.component';
import { SerialNoCellComponent } from '../../../table-cell/serial-no-cell.component';
import {
  GlobalRespo,
  GlobalResponseData,
} from '../../../services/raintree/interfaces/global-respo';
import { MasterSearchTransmissionService } from '../../../services/raintree/Transmission/master-search.service';
import { SerialNoUpdateCellComponent } from '../../../table-cell/serial-no-update-cell.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DpLoaderComponent } from "../../../common-component/dp-loader/dp-loader.component";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'name-search-tab',
  standalone: true,
  templateUrl: './name-search-tab.component.html',
  styleUrl: './name-search-tab.component.scss',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    DpTableComponent,
    InfiniteScrollModule,
    DpLoaderComponent
],
})
export class NameSearchTabComponent implements OnInit {
  responseData: any = [];
  isLoader:boolean = false;
  public pageNo = 1;
  public pageSize = 200;
  numberOfLoaders=20;
  nameSearchForm!: FormGroup;

  @Input() data: any;
  @Output() serialNo: EventEmitter<any> = new EventEmitter<any>();
  
  noDataFound: boolean=false;

  constructor(private _masterSearchService: MasterSearchTransmissionService,
    public toaster: ToastrService,
  ) {
    this.nameSearchForm = new FormGroup({
      firstName: new FormControl('',[
        Validators.required,
        Validators.pattern('[-_a-zA-Z0-9 ]*'),
      ]),
      lastName: new FormControl('',[Validators.pattern('[-_a-zA-Z0-9 ]*'),]),
      guardianFirstName: new FormControl('',[Validators.pattern('[-_a-zA-Z0-9 ]*'),]),
      guardianLastName: new FormControl('',[Validators.pattern('[-_a-zA-Z0-9 ]*'),]),
      pageNo: new FormControl(1),
      pageSize: new FormControl(200),
      selectedRadioButton: new FormControl('EX'),
    });
    this.nameSearchForm.get('lastName')?.disable();
    this.nameSearchForm.get('guardianLastName')?.disable();
  }

  setupFormListeners() {
    this.nameSearchForm.get('firstName')?.valueChanges.subscribe(value => {
      if (value) {
        this.nameSearchForm.get('lastName')?.enable();
      } else {
        this.nameSearchForm.get('lastName')?.reset();
        this.nameSearchForm.get('lastName')?.disable();
      }
    });

    this.nameSearchForm.get('guardianFirstName')?.valueChanges.subscribe(value => {
      if (value) {
        this.nameSearchForm.get('guardianLastName')?.enable();
      } else {
        this.nameSearchForm.get('guardianLastName')?.reset();
        this.nameSearchForm.get('guardianLastName')?.disable(); 
      }
    });
  }

  ngOnInit(): void {
    this.setupFormListeners();
  }

  public displayColumnData: any = [
    {
      id: 'slNo',
      name: 'Sl.No',
    },
    {
      id: 'memberStatus',
      name: 'Mem Status',
    },
    {
      id: 'district',
      name: 'District',
    },
    {
      id: 'fullName',
      name: 'Name',
    },
    {
      id: 'guardianFullName',
      name: 'Guardian',
    },
    {
      id: 'initiationDate',
      name: 'Initiation Date',
    },
    {
      id: 'ritwik',
      name: 'Ritwik',
    },
    {
      id: 'pincode',
      name: 'Pin',
    },
    {
      id: 'address',
      name: 'Adress',
    },
  ];

  columnConfs = {
    memberStatus: { cssClass: 'memberStatuswidth' },
    pincode: { cssClass: 'pincodewidth' },
  };

  cellComponentMap = {
    slNo: SerialNoUpdateCellComponent,
  };

  getFormValue(controlName: string): any {
    return this.nameSearchForm.get(controlName)?.value;
  }

  onNameSearch(isStart: boolean) {
    if (this.nameSearchForm.valid){
      if (isStart) {
        this.responseData = [];
        this.pageNo = 1;
        this.isLoader = true;
      } else {
        this.pageNo += 1;
      }
      
      this.nameSearchForm.controls['pageNo'].setValue(this.pageNo);
      this.nameSearchForm.controls['pageSize'].setValue(this.pageSize);
  
      let nameSearchObj = {
        sType: this.getFormValue('selectedRadioButton')? this.getFormValue('selectedRadioButton'): 'EX',
        fName: this.getFormValue('firstName'),
        lName: this.getFormValue('lastName'),
        guardianFirstName: this.getFormValue('guardianFirstName'),
        guardianLastName: this.getFormValue('guardianLastName'),
        pageNo: this.getFormValue('pageNo'),
        offSet: this.getFormValue('pageSize'),
      };
  
      this._masterSearchService.fetchNameSearchRecords(nameSearchObj).subscribe({
        next: (response: GlobalResponseData) => {
          this.isLoader = false;
          this.noDataFound = false;
          
          if (response.data.memberList.length === 0) {
            this.isLoader = false;
            if(isStart){
              this.noDataFound=true;
            }
          }
          else{
            this.responseData = [...this.responseData,...response.data.memberList.map(
              (user: GlobalRespo) => {
                return {
                  slNo: user.mk,
                  fullName: user.fn + ' ' + user.ln,
                  district: user.dn,
                  memberStatus: 'FW Pending',
                  guardianFullName: user.gfn + ' ' + user.gln,
                  initiationDate: user.md,
                  ritwik: user.rn,
                  pincode: user.pn,
                  address: user.add,
                };
              }
            )];
          } 
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
    else{
      this.toaster.error("Enter a valid Name");
      this.nameSearchForm.get('selectedRadioButton')?.setValue('EX');
    }
  }

  onScroll(){
    console.log('scroll event occured')
    this.pageNo+=1;
    this.onNameSearch(false);
  }

  onCellClick(event: any) {
    this.serialNo.emit(event);
  }

  onclickClear() {
    console.log('on clear clicked');
    this.responseData = [];
    this.nameSearchForm.get('selectedRadioButton')?.setValue('EX');
  }
}
